import { CLINICARD_NAMES } from 'constants/constants';
import defaultConfigs from './default';

const AWS = {
  aws_project_region: 'eu-west-1',
  aws_cognito_identity_pool_id:
    'eu-west-1:d2109ce9-523a-43c4-8db3-2594d587a0ae',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_7PfmEO6kM',
  aws_user_pools_web_client_id: '6pjk6pnfk7q1mkv8cmu843v1e3',
  oauth: {},
  aws_appsync_graphqlEndpoint:
    'https://flv24gz6lrekvfakah3ec5zqie.appsync-api.eu-west-1.amazonaws.com/graphql',
  aws_appsync_region: 'eu-west-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_appsync_apiKey: 'da2-fakeApiId123456',
  aws_cloud_logic_custom: [],
  aws_user_files_s3_bucket:
    'amplify-d1uyp2w4x09cae-ma-cortexstoragebucket07edc-8hgzlnco6fux',
  aws_user_files_s3_bucket_region: 'eu-west-1',
};

const defaultCarepathCards = [
  'bmi',
  'prosthesis_questionnaire',
  'prepare_visit',
  'mood',
  'caregiver_strain_index',
  'vas_painscore',
  'steps',
  'photo',
  'exercises',
  'goals',
  'temperature',
  'blood_pressure',
  'heartrate',
  'saturation',
  'vas_painscore',
  'treatment_questionnaire',
  'information_questionnaire',
  'eating_questionnaire',
  'exercises_questionnaire',
  'breastfeeding',
];

const medProfileQuestions = ['length'];

export default {
  ...defaultConfigs,
  APP_TITLE: 'CORTEX',
  APP_CODE: 'CLIN-APP-0000', // TODO: update with actual app code
  CONTENT_LANGUAGE: 'nl',
  CONTENT_LANGUAGES: ['nl', 'en'],
  ENABLE_CE: true,
  ENABLE_ARTICLES: true,
  ENABLE_CAREPATH: true,
  ENABLE_STACKED_CAREPATH: true,
  ENABLE_CARDS: true,
  ENABLE_MEDICAL_PROFILE: false,
  ENABLE_MANAGEMENT: true,
  ENABLE_PERMISSIONS: true,
  ENABLE_SIGNALING: true,
  ENABLE_PERSONAL_MESSAGES: true,
  ENABLE_ORGANISATION_LEVEL: true,
  ENABLE_ORGANISATION_DETAILS: true,
  ENABLE_ORGANISATION_MULTIPLE: true,
  ENABLE_OPERATION_PROFILE: true,
  ENABLE_STICKY_CAREPATHITEM: true,
  ENABLE_ACTIVATIONPERIOD_CAREPATHITEM: true,
  ENABLE_RANDOMISATION: true,
  ENABLE_CAREPATHS_ARTICLES: true,
  ENABLE_INSTANCE_SPECIC_NAMING: true,
  ENABLE_USER_REINVITATION: true,
  INSIGHTS_GRAPH_WHITELIST: [CLINICARD_NAMES.CSI],
  AWS,
  defaultCarepathCards,
  MEDICAL_PROFILE_QUESTIONS: medProfileQuestions,
  ENABLE_USAGE_ACTIVITY: true,
  ENABLE_ANALYSE: true,
  VISUALISE_INACTIVE_USERS: true,
  ENABLE_SORT_LIST: true,
  ENABLE_REPEAT_CAREPATH: true,
  DELETE_ARTICLES: true,
  DELETE_CAREPATHS: true,
  ENABLE_INTELLIGENCE: true,
};
